export const allowedFileTypes = ['jpg', 'jpeg', 'png', 'gif', 'jfif', 'pjpeg', 'pjp', 'svg', 'bmp', 'tif', 'tiff', 'webp', 'ico', 'jp2', 'heic', 'heif', 'wbmp'];

export const activeAllowedType = ['jpg', 'jpeg', 'png'];

export const uploadDocumentType = ['png', 'jpg', 'jpeg', 'pdf', 'vnd.ms-excel', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                    'msword', 'vnd.openxmlformats-officedocument.wordprocessingml.document', 'vnd.openxmlformats-officedocument.presentationml.presentation', 'vnd.ms-powerpoint'];